import React, { useEffect, useState } from "react";
import Backdrop from "../../asserts/CRMbg.png";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Spin,
  Tooltip,
  Popover,
  ConfigProvider,
  DatePicker,
  Space,
  Select,
  Pagination
} from "antd";
import "../../App.css";
import { LiaSearchSolid } from "react-icons/lia";
import { BsExclamationCircle } from "react-icons/bs";
import moment from "moment";
import {PaymentsDashboard} from "./PaymentsDashboard";
import PaymentTable from "./PaymentTable";
import SettlementTable from "./SettlementTable";
import RefundTable from "./RefundTable";
import { MdCancel } from "react-icons/md";
import { GetPaymentDetails,GetRefundDetails,GetSettlementDetails,GetSettlementByMonth,GetRazorpayDetails, GetRefundRequestDetails, handleRefundRequestDetailsSearch, handleCommission, handleCommissionSearch,} from "../../Api/Payments/Payments";
import {handlePaymentsearch,handleSettlementsearch,handleRefundsearch} from "../../Api/Payments/Payments";
import { FaSearch } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
 faXmark
} from "@fortawesome/free-solid-svg-icons";
import RefundRequestTable from "./RefundRequest";
import { FaMobileAlt,FaDesktop } from "react-icons/fa";
import all1 from "../../asserts/all1.png";
import all2 from "../../asserts/all2.png";
import Commission from "./Commission";
import { RazorpayDashboard } from "./RazorpayDashboard";
import exporticon from "../../asserts/Export.png"
import {RazorpaydashMobile} from "./RazorpaydashMobile";
import { RiMenuFill } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

// import {GetCancellationDetails} from"../../Api/Dashboard/Dashboard";
// import CancelTable from "../Dashboard/CancelTable";


const MonthPicker=DatePicker;
const Option=Select;

const Payments = () => {
  const location = useLocation();
  const [spinning, setSpinning] = useState(false);
  const [loader,setLoad]=useState(false);
  const [table, setTable] = useState(
    location?.state?.tabIndex || "razorpaydashboard"
  );
  const [activePage, setActivePage] = useState(1);
  const [isDisabled, setIsDisabled] = useState(true);
  const [inputValue,setInputValue]=useState()
const [isClearing, setIsClearing] = useState(false);
const [searchSymbol,setSearchSymbol]=useState("%")
const [dates, setDates] = useState();
const[monthFetch,setMonth]=useState();
const[yearFetch,setYear]=useState();
const[inputMonth,setinputMonth]=useState();
const [deviceid, setDeviceId] = useState(0);
const [isView, setIsView] = useState("All");
const[showtable,setShowTable]=useState(1);
const crud=sessionStorage.getItem("crud_permission")
const [dropdownOpen, setDropdownOpen] = useState(false);
 
  const handleDragStart = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
  };

  
  useEffect(() => {
    setSpinning(true)
    GetRazorpayDetails(dispatch, setSpinning, setLoad, "null", "null", 1);
  }, [])

const handleClick=(value)=>{
  console.log(value,"vvvvvvvvvvv")
  if(value==="dashboard"){
    setTable("razorpaydashboard")

  }else if(value==="commission"){
    setTable("commission")
  }
}


const monthfilter = async (values) => {
  setSpinning(true);
    try {
      setDates(values)
      setDateClear(values);
      
      console.log(values, "date values");
      if (table == "settlements") {
       
        await GetSettlementByMonth(
          dispatch,
         setSpinning,
          moment(values.$d).format("MM"),

          moment(values.$d).format("YYYY"),
          
        );
        
      //    setMonth(moment(values.$d).format("MM"),)
      // console.log(monthFetch,"MONTH")
      // setYear(moment(values.$d).format("YYYY"),)
       console.log(spinning,"Year")
      }
      
      setActivePage(1);
          } catch (err) {
            console.log(err, "error");
            if (table == "settlements") {
              
              GetSettlementDetails(10, 0, dispatch, setSpinning);
              
            }
          }
        }

      

    const changeMonthPickerPlaceholder = () => {
    const inputDiv = document.querySelector(".ant-picker-input");
    if (inputDiv) {
      const inputElement = inputDiv.querySelector("input");
      if (inputElement) {
              }
    }
  }
  changeMonthPickerPlaceholder();
  

  const dispatch = useDispatch();
  //   const getPayDashboardDetails =
  //     useSelector((state) => state.crm.dashboard_details) || [];
  //   console.log(getDashboardDetails, "DASHBOARD details dashboard");
  // useEffect(() => {
  //   setSpinning(true);
  //   if(table=="payments"){
  //     GetPaymentDetails(10,0,dispatch,setSpinning)
  //   }
     
    
  // }, []);
  const handleClear = () => {
    
      setInputValue('');
      if(table=="payments"){
        setSpinning(true);
        GetPaymentDetails(10, 0, dispatch, setSpinning);
      }else if(table=="settlements"){
        setSpinning(true);
        GetSettlementDetails(10, 0, dispatch, setSpinning);
        
      }else if(table=="refunds"){
        setSpinning(true);
        GetRefundDetails(10, 0, dispatch, setSpinning);
      }else if(table=="commission"){
        handleCommission(dispatch);

      }else if(table=="razorpaydashboard"){
        setSpinning(true);
        GetRazorpayDetails(dispatch,setSpinning,setLoad,"null","null",1);
      }
    }

  const infos = [
    {
      title: "Payment ID",
    },
    
  ];

  const infos2 = [
    {
      title: "Settlement ID",
    },
    
  ];

  const infos3 = [
    {
      title: "Refund ID",
    },
  ];
    const infos4 = [
      {
      title: "Ticket Number",
    },
    
  ];
    const infos5=[

    {
      title:"Payment Id"
    }
    ];
    
    // {
    //   title: "Activated Date",
    //   description: "DD MMM (e.g. 01 Jan) - Format",
    // },
    // {
    //   title: "Expiry Date",
    //   description: "DD MMM (e.g. 01 Jan) - Format",
    // },
  

  const Search = (inputValue) => {
    setSpinning(true);
      if (table == "payments") {
        handlePaymentsearch(inputValue, dispatch,setSpinning);
        setActivePage(1);
      } else if (table == "settlements") {
        handleSettlementsearch(inputValue, dispatch,setSpinning);
        setActivePage(1);
      } else if (table == "refunds") {
        handleRefundsearch(inputValue, dispatch,setSpinning);
        setActivePage(1);
      } 
      // else if(table=="refundRequest"){
      //   handleRefundRequestDetailsSearch(inputValue, dispatch,setSpinning);
      //   setActivePage(1);
      // }
      else if(table=="commission"){
        handleCommissionSearch(inputValue,dispatch,setSpinning);
        setActivePage(1);
      }
  };

  const handleKeyDown = (e) => {
    // Allow control keys like Backspace, Delete, ArrowLeft, ArrowRight, Tab
    const isControlKey = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(e.key);

    if (isControlKey) {
      return; // If it's a control key, do nothing and allow it to execute
    }

    // Allow only alphabets (A-Z, a-z), numbers (0-9), and space
    if (!/^[A-Za-z0-9\s]$/.test(e.key)) {
      e.preventDefault(); // Prevent the key if it's not an alphabet, number, or space
    }
  };

  const { RangePicker } = DatePicker;

  // date picker
  const changeDatePickerPlaceholder = () => {
    const inputDiv = document.querySelector(".ant-picker-input");
    if (inputDiv) {
      const inputElement = inputDiv.querySelector("input");
      if (inputElement) {
        inputElement.placeholder = "Start Date";
        inputElement.className = "text-center";
      }
    }
  };

  const changeDatePickerPlaceholder2 = () => {
    const inputDiv = document.querySelector(".ant-picker");
    if (inputDiv) {
      const children = inputDiv.querySelectorAll("div");
      if (children.length > 2) {
        const thirdChild = children[2];
        const inputElement = thirdChild.querySelector("input");
        if (inputElement) {
          inputElement.placeholder = "End Date";
          inputElement.className = "text-center";
        }
      }
    }
  };

  useEffect(() => {
    changeDatePickerPlaceholder();
    changeDatePickerPlaceholder2();
  }, [table]);

  const [dateClear, setDateClear] = useState();
  
  console.log("dateZClear",dateClear)
  const datefilter = async (values) => {
    try {
      setSpinning(true);
      setDateClear(values);
      console.log(values, "date values");
     
        await GetRazorpayDetails(
          dispatch,setSpinning,setLoad,
          moment(values[0].$d).format("YYYY-MM-DD"),
          moment(values[1].$d).format("YYYY-MM-DD"),
          1
        );
    } catch (err) {
      console.log(err, "error");
      setSpinning(true);
      GetRazorpayDetails(dispatch,setSpinning,setLoad,"null","null",1);

    }
  };

  useEffect(() => {
    // setTable(location?.state?.tabIndex);
    if (showPayments) {
        setTable(
        location?.state?.tabIndex ? location?.state?.tabIndex : "payments"
      );
    } else if(showSettlements){
        setTable("settlements")
      } else if(showRefunds){
        setTable("refunds")
      }else if(showCommission){
        setTable("commission")
      }
      else if(showDashboard){
        setTable("commission")
      }
  }, [location.state]);
  useEffect(() => {
    if (table === "payments") {
        if(showPayments){
          setTable(
        location?.state?.tabIndex ? location?.state?.tabIndex : "payments"
      );
        }
      else if(showSettlements){
        setTable("settlements")
      } else if(showRefunds){
        setTable("refunds")
      }else if(showCommission){
        setTable("razorpaydashboard")
      }
      else if(showDashboard){
        setTable("razorpaydashboard")
      }
    } 
  }, [table]);

  

  const storedModulePermissions = sessionStorage.getItem("module_permission");
  const currenttypeid = sessionStorage.getItem("type_id");
  const modulePermissions = storedModulePermissions
    ? JSON.parse(storedModulePermissions)
    : [];
  const paymentModule = [4];
  const showPayments = paymentModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const settlementModule = [5];
  const showSettlements = settlementModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
  const refundModule = [6];
  const showRefunds = refundModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
   const commissionModule = [33];
  const showCommission = commissionModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
   const dashboardModule = [34];
  const showDashboard = dashboardModule.some((id) =>
    modulePermissions?.some((permission) => permission.module_id === id)
  );
    const access = sessionStorage.getItem("accessId");

  return (
    <div
      className={`h-screen w-screen px-[2.5vw]`}
      style={{
        backgroundImage: `url(${Backdrop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h1 className="hidden md:block text-[#1F4B7F] pt-[0.5vw] text-[1.5vw] font-bold">
        {
          table==="razorpaydashboard"?
          "RAZORPAY DASHBOARD":
          table==="commission"?
          "COMMISSION":
          table==="payments"? 
          "PAYMENTS":
          table == "settlements"
          ? "SETTLEMENTS"
          : table == "refunds"
          ? "REFUNDS":
          ""
          }
          
        
      </h1>
            <h1 className="block md:hidden text-[#1F4B7F] pt-[1vw] text-[4vw] font-bold">
        {
          table==="razorpaydashboard"?
          "RAZORPAY DASHBOARD":
          table==="commission"?
          "COMMISSION":
          table==="payments"? 
          "PAYMENTS":
          table == "settlements"
          ? "SETTLEMENTS"
          : table == "refunds"
          ? "REFUNDS":
          ""
          }
          
        
      </h1>

<div className="block md:hidden">
  <div className="flex flex-wrap justify-between gap-x-2 mb-[2vw] items-start">
    
<div className="flex flex-row gap-x-2">
<div className="flex justify-start items-start">
          <Select
          showSearch={false}
          value=""
          className={`custom-select bg-white border-r-[0.75vw] text-[2vw]  border-l-[0.1vw] border-t-[0.1vw] border-b-[0.75vw] border-[#1F487C] placeholder-blue text-[#1F487C] h-[5.5vw] rounded-[1vw] outline-none `}
 
                    style={{height: "7vw", width: "7vw", padding: 0 }} 
                    dropdownStyle={{ width: "30vw"}} 
                    placeholder=""
                    optionFilterProp="value"
                    suffixIcon={
  <span
    style={{
      color: "#1f487c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      marginTop:'2vw',
      marginLeft:'-1.3vw'
    }}
  >
    {dropdownOpen ? <RxCross2 size="5vw" /> : <RiMenuFill size="5vw" />}
  </span>

}

          onChange={handleClick}
          onDropdownVisibleChange={(open) => setDropdownOpen(open)}
        >
          <Option value="dashboard">Dashboard</Option>
          <Option value="commission">Commission</Option>
        </Select>
</div>
      {/* Search Input + Icon */}
    <div className="relative flex items-center w-[30vw] h-[7vw]">
      <LiaSearchSolid
        className="absolute left-[1vw]"
        size="12px"
        color="#9CA3AF"
      />
      <input
        type="text"
        value={inputValue}
        className={`bg-white outline-none pl-[4.5vw] pr-[7vw] text-[#1f487c] w-full h-full text-[2.5vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.75vw] border-r-[0.75vw] rounded-[1vw] ${
          table === "razorpaydashboard"
            ? "cursor-not-allowed hover:bg-zinc-500 pointer-events-none"
            : ""
        }`}
        placeholder="Search..."
        onKeyDown={handleKeyDown}
        onChange={(e) => setInputValue(e.target.value)}
        onBlur={(e) => setInputValue(e.target.value)}
        onDragStart={handleDragStart}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        disabled={isDisabled}
      />
      {/* Clear or Info Icon */}
      <div className="absolute right-[2vw] top-1/2 -translate-y-1/2">
        {inputValue ? (
          <FontAwesomeIcon
            icon={faXmark}
            size="1.5vw"
            className="text-[#9CA3AF] cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              handleClear();
            }}
          />
        ) : (
          <Popover
            color="white"
            placement="bottom"
            title={
              table === "razorpaydashboard" ? (
                ""
              ) : (
                <div className="text-[#1F4B7F] p-[1vw] max-h-[20vw] overflow-auto">
                  <span className="font-bold">SEARCH BY...</span>
                  {(table === "payments"
                    ? infos
                    : table === "settlements"
                    ? infos2
                    : table === "refunds"
                    ? infos3
                    : table === "commission"
                    ? infos4
                    : infos4
                  ).map((info, index) => (
                    <div key={index} className="flex flex-col">
                      <ul className="pl-[1vw]" style={{ listStyleType: "disc" }}>
                        <li className="text-[0.8vw]">
                          <p>{info.title}</p>
                        </li>
                      </ul>
                      <span className="text-[.7vw] pl-[1vw] text-[#9CA3AF]">
                        {info.description}
                      </span>
                    </div>
                  ))}
                </div>
              )
            }
          >
            <BsExclamationCircle
              size="12px"
              color="#9CA3AF"
              className={`${
                table === "razorpaydashboard"
                  ? "cursor-not-allowed"
                  : "cursor-default"
              }`}
            />
          </Popover>
        )}
      </div>
    </div>
    </div>

    {/* Date Picker */}
    <div className="relative flex items-center w-[40vw]">
      <ConfigProvider
        theme={{
          token: {
            fontSize: "2.3vw",
            lineHeight: 0.5,
            colorPrimary: "#1F487C",
          },
          components: {
            DatePicker: {
              activeBorderColor: "#1F487C",
              hoverBorderColor: "#1F487C",
              activeShadow: "#1F487C",
              cellWidth: 20,
              cellHeight: 10,
              padding: "1vw",
            },
          },
        }}
      >
        <RangePicker
          allowClear={true}
          autoFocus={false}
          onChange={datefilter}
          value={dateClear}
          placement="bottomLeft"
          getPopupContainer={(trigger) => trigger.parentNode}
          className="border-l-[0.1vw] border-t-[0.1vw] border-b-[0.75vw] border-r-[0.75vw] border-[#1F487C] text-[#1F487C] text-[2.5vw] h-[7vw] w-full rounded-[1vw] px-[2vw] bg-white"
          popupClassName="custom-datepicker-popup"
        />
      </ConfigProvider>
    </div>
</div>
  </div>


      <div className="hidden md:flex items-start justify-between">
   
                 <div className="flex space-x-14">
                  <div className="flex items-center gap-[0.5vw] pb-[0.5vw]">
  {/* Input + Icons */}
  <div className="relative flex items-center">
          <LiaSearchSolid
                className="absolute left-[0.5vw] inline-block "
                size={"1.1vw"}
                color="#9CA3AF"
              />
    {/* Search Input */}
    <input
      type="text"
      value={inputValue}
      className={`${
              table === "razorpaydashboard"
                ? "cursor-not-allowed hover:bg-zinc-500"
                : ""
            } bg-white outline-none pt-[0.25vw] pl-[2vw] pr-[2.5vw] w-[15vw] text-[#1f487c] h-[5vh] text-[1vw] border-[#1F4B7F] border-[0.1vw] rounded-[0.75vw] `}
      placeholder="Search..."
      onKeyDown={handleKeyDown}
      onChange={(e) => setInputValue(e.target.value)}
      onBlur={(e) => setInputValue(e.target.value)}
       onDragStart={handleDragStart}
                    onDrop={handleDrop}
                    onDragOver={(e) => e.preventDefault()}
                    disabled={isDisabled}
    />

    {/* Conditional Icon (Clear or Info) */}
    <div className="absolute right-[0.8vw] top-1/2 -translate-y-1/2">
      {inputValue ? (
        <FontAwesomeIcon icon={faXmark} size="2vw" className="text-[#9CA3AF] cursor-pointer" onClick={(e) => {
            e.preventDefault();
            handleClear();
          }}/>
     
      ) : (
        <Popover
          color="white"
          placement="bottom"
          title={
            table == "razorpaydashboard" ? (
                  ""
                ) : (
            <div className="text-[#1F4B7F] p-[1vw] max-h-[20vw] overflow-auto">
              <span className="font-bold">SEARCH BY...</span>
              {(table === "payments" ? infos : table === "settlements" ? infos2 :table==="refunds"? infos3 :table==="commission"?infos4:infos4).map(
                (info, index) => (
                  <div key={index} className="flex flex-col">
                    <ul className="pl-[1vw]" style={{ listStyleType: "disc" }}>
                      <li className="text-[0.8vw]">
                        <p>{info.title}</p>
                      </li>
                    </ul>
                    <span className="text-[.7vw] pl-[1vw] text-[#9CA3AF]">
                      {info.description}
                    </span>
                  </div>
                )
              )}
            </div>
                )
          }
        >
         <BsExclamationCircle
  size="17px"
  color="#9CA3AF"
  className={`align-middle leading-none mr-[4px] mb-[2px] ${table==="razorpaydashboard"?"cursor-not-allowed":"cursor-default"}`}
/>
        </Popover>
      )}
    </div>
  </div>

  {/* Search Button */}
  <div
    className={`bg-[#1F4B7F] h-[5vh] w-[3vw] hidden md:flex items-center justify-center rounded-[0.75vw] ${table==="razorpaydashboard"?"cursor-not-allowed":"cursor-pointer"}`}
    onClick={() =>
       Search(inputValue)
     
      }
      
  >
    
    <FaSearch size="1.1vw" color="white" className={`${table==="razorpaydashboard"?"cursor-not-allowed":"cursor-pointer"}`} />
  </div>
</div>
 
                 </div>

                 <div className="hidden md:flex text-[1.1vw]  gap-x-8 items-start ml-[2vw]">
                   <div className={`${showDashboard || currenttypeid === "PRO101" ? "" : "cursor-not-allowed"}`}>
            <div
            className={` cursor-pointer ${
              table==="razorpaydashboard"
                ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                : ""
            } ${showDashboard || currenttypeid === "PRO101" ? "" : "pointer-events-none"}`}
            onClick={() => {
             setTable("razorpaydashboard")
             setShowTable(1)
             setIsDisabled(true);
             setInputValue('');
              
            }}
          >
            <div className="text-[1.3vw] text-[#1f487c] text-center">
              Dashboard
            </div>
          </div>
          </div>
          
          <div className={`${showCommission || currenttypeid === "PRO101" ? "" : "cursor-not-allowed"}`}>
            <div
            className={` cursor-pointer ${
             table==="commission"
                ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                : ""
            } ${showCommission || currenttypeid === "PRO101" ? "" : "pointer-events-none"}`}
            onClick={() => {
            setIsDisabled(false)
            setTable("commission")
            setInputValue('');
            }}
          >
            <div className="text-[1.3vw] text-[#1f487c] text-center">
              Commission
            </div>
          </div>
          </div>
        
          
                  
                  </div>

        <div className="grid grid-cols-3   ">
      
       {
        access==="1"?  
        <div className="col-span-1 ml-[2vw]">
               <div className="flex  justify-start items-center gap-x-12">
                  <div className={`${showPayments || currenttypeid === "PRO101" ? "" : "cursor-not-allowed"}`}>
            <div
            className={` cursor-pointer ${
              table == "payments"
                ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                : ""
            } ${showPayments || currenttypeid === "PRO101" ? "" : "pointer-events-none"}`}
            onClick={() => {
              setTable("payments");
              setIsDisabled(false);
              setActivePage(1);
              setInputValue('');
              setShowTable(1)
              
            }}
          >
            <div className="text-[1.3vw] text-[#1f487c] text-center">
              Payments
            </div>
          </div>
          </div>

          <div className={`${showSettlements || currenttypeid === "PRO101" ? "" : "cursor-not-allowed"}`}>
            <div
            className={` cursor-pointer ${
              table == "settlements"
                ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                : ""
            } ${showSettlements || currenttypeid === "PRO101" ? "" : "pointer-events-none"}`}
            onClick={() => {
              setTable("settlements");
              setIsDisabled(false);
              setActivePage(1);
              setInputValue('');
              setShowTable(1)
            }}
          >
            <div className="text-[1.3vw] text-[#1f487c] text-center">
              Settlements
            </div>
          </div>
          </div>

            <div className={`${showRefunds || currenttypeid === "PRO101" ? "" : "cursor-not-allowed"}`}>
            <div
            className={` cursor-pointer ${
              table == "refunds"
                ? "border-b-[0.25vw] font-bold border-[#1f487c]"
                : ""
            } ${showRefunds || currenttypeid === "PRO101" ? "" : "pointer-events-none"}`}
            onClick={() => {
              setTable("refunds");
              setIsDisabled(false);
              setActivePage(1);
              setInputValue('');
              setShowTable(1)
            }}
          >
            <div className="text-[1.3vw] text-[#1f487c] text-center">
              Refunds
            </div>
          </div>
          </div>
               </div> 
        </div>
        :""
       }

        <div className="col-span-1 flex ml-[24vw] ">
          {table==="settlements"?(
            <div>
              
              <Space direction="vertical">

              <MonthPicker
              name="month"
              id="month"
              class="month"
              placeholder="Select Month"
              picker="month" 
              className="flex justify-center  text-[#1f487c] h-[4.6vh] w-[10vw] mt-[0.1vw]"
              allowClear={true}
              autoFocus={false}
              onChange={monthfilter}
              value={dateClear} 
              />
        
              
              </Space>
        
              </div>
          ):(" ")
        }





        </div>

        </div>
        {table === "razorpaydashboard" ? (
          <div className="flex items-center ">
                            <div className="relative flex items-center w-[15vw]">
                  <div className="reqman">
                    <ConfigProvider
                      theme={{
                        token: {
                          fontSize: ".9vw",
                          lineHeight: 0,
                          colorPrimary: "#1F487C",
                        },
                        components: {
                          DatePicker: {
                            activeBorderColor: "#1F487C",
                            hoverBorderColor: "#1F487C",
                            activeShadow: "#1F487C",
                            cellWidth: 25,
                            cellHeight: 20,
                          },
                        },
                      }}
                    >
                      <RangePicker
                        allowClear={true}
                        autoFocus={false}
                        onChange={datefilter}
                        value={dateClear}
                        inputReadOnly={true}
                        className="ads-date1 border-r-[0.75vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]
                        text-[#1F487C] text-[0.8vw] h-[5vh] w-full rounded-[0.5vw] outline-none px-[1vw] placeholder-[#1F487C]"
                      />
                    </ConfigProvider>
                  </div>
                </div>
            <div className="hidden md:flex ml-[1vw]  items-center gap-x-[0.5vw] justify-center bg-[#1F487C] w-[10vw] h-[5vh] rounded-lg px-[1vw] py-[1vw]">
                                                 <img
                                                 src={exporticon}
                                                 alt="Export"
                                                 className="w-[1vw] h-[1vw]"
                                                 ></img>
                                                <label className="text-[1vw] font-semibold text-white">
                                                  Export
                                                </label>
                                              </div>
          </div>

          
        ) : (
          ""
        )}
      </div>
{
  showtable===1?
( 
      table == "payDashboard" ? (
       <PaymentsDashboard />
      ) : table == "payments" ? (
        <PaymentTable activePage={activePage} setActivePage={setActivePage}  />
      ) : table == "settlements" ? (
        <SettlementTable activePage={activePage} setActivePage={setActivePage} dateClear={dateClear}  />
      ) : table == "refunds" ? (
        <RefundTable activePage={activePage} setActivePage={setActivePage} />
      // ) : table == "blocked" ? (
      //   <PaymentsDashboard activePage={activePage} setActivePage={setActivePage} />
      ) :table=="refundRequest" ?(
        <RefundRequestTable activePage={activePage} setActivePage={setActivePage} deviceid={deviceid}/>
      ):table=="razorpaydashboard" ?(
        <>
        <div className="hidden md:block">
          <RazorpayDashboard dateClear={dateClear} spinning={spinning} setSpinning={setSpinning} loader={loader} setLoad={setLoad}/>
        </div>
        <div className="block md:hidden">
          <RazorpaydashMobile dateClear={dateClear} spinning={spinning} setSpinning={setSpinning} loader={loader} setLoad={setLoad} table={table} datefilter={datefilter}/>
        </div>
        </>
      ):table=="commission" ?(
        <Commission />
      ):("")
    ):("")
    
}
    
      


       
    </div>
    
  );
  
};

export default Payments;
{/* <div className="flex items-center gap-[0.5vw]">
  //                                   <FaSearch
  //   size="1.1vw"
  //   className="text-[#1F4B7F]"
  //   onClick={()=>{
  //     Search(inputValue)
      
  //   }}
  // />
  // <MdCancel
  //   size="1.2vw"
  //   className="text-[#1f487c] cursor-pointer"
  //   onClick={(e) => {
  //     e.preventDefault();
  //     handleClear();
  //   }}
  // /></div> */}